import { observer } from 'mobx-react-lite';

import { useParams } from 'react-router';
import styles from './index.module.scss';
import classNames from 'classnames';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import useRtmEventsService from './service';

const EventMeta = ({ uuid }: { uuid: string }) => {
  const { patientUuid = '' } = useParams<{ patientUuid: string }>();
  const { isEventInEditableDateRange, getEvent } = useRtmEventsService(patientUuid);
  const event = getEvent(uuid);
  const amendedCount = (event?.versions?.length ?? 0) - 1;

  return !isEventInEditableDateRange(uuid) || event?.isVoid || amendedCount > 0 ? (
    <div className={classNames('flex', styles.meta)}>
      {!isEventInEditableDateRange(uuid) ? (
        <span
          className={classNames(
            'flex items-center gap-x-0.5',
            styles.label,
            styles.notEditable,
          )}
        >
          <LockOutlinedIcon /> No longer editable
        </span>
      ) : null}
      {event?.isVoid ? <span className={classNames(styles.label, styles.voided)}>Void</span> : null}
      {amendedCount > 0 ? (
        <span className={classNames(styles.label, styles.amendedCount)}>
          {amendedCount}
          {amendedCount === 1 ? ' Amendment' : ' Amendments'}
        </span>
      ) : null}
    </div>
  ) : null;
};

export default observer(EventMeta);
